import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { url } from 'src/environments/environment.prod';
import { EventDto } from './eventDto';
import { MessageFeedDto } from './messageFeedDto';


@Injectable({
  providedIn: 'root'
})

export class CalendarService {

  constructor(
    private httpClient: HttpClient
  ) { }

  getEvents(): Observable<EventDto[]> {
    return this.httpClient.get<EventDto[]>(url + '/post/events');
  }

  getMessageFeeds(): Observable<MessageFeedDto[]> {
    return this.httpClient.get<MessageFeedDto[]>(url + "/messagefeed");
  }

  createMessageFeed(title: string, message: string, user: string, date: string): Observable<MessageFeedDto> {
    return this.httpClient.post<MessageFeedDto>(url + "/messagefeed/create", {"title": title, "message": message, "user": user, "date": date});
  }

  deleteMessageFeed(id: string): Observable<Boolean> {
    return this.httpClient.post<boolean>(url + "/messagefeed/delete", id);
  }

}